import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxEchartsModule } from 'ngx-echarts';
import { EChartsOption } from 'echarts';

import { DonutChartConfig } from 'src/app/core/charts/configs/donut-chart.config';
import {
  ReportCardSummary,
  FINDING_STATUS_CONFIG,
  ALIGNMENT_LABEL_CONFIG,
} from '../../services/policy-gap-analysis.service';

@Component({
  selector: 'app-report-card-summary',
  standalone: true,
  imports: [CommonModule, NgxEchartsModule],
  templateUrl: './report-card-summary.component.html',
  styleUrl: './report-card-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportCardSummaryComponent {
  reportCard = input.required<ReportCardSummary>();
  showTitle = input<boolean>(true);

  alignmentConfig = computed(() => ALIGNMENT_LABEL_CONFIG[this.reportCard().alignment_label]);

  chartOptions = computed<EChartsOption>(() => {
    const rc = this.reportCard();
    return DonutChartConfig.create({
      data: [
        { name: 'Validated', value: rc.validated_count, color: FINDING_STATUS_CONFIG.validated.color },
        { name: 'Not Validated', value: rc.documented_not_validated_count, color: FINDING_STATUS_CONFIG.documented_not_validated.color },
        { name: 'Recommended', value: rc.recommended_not_documented_count, color: FINDING_STATUS_CONFIG.recommended_not_documented.color },
        { name: 'Not Verifiable', value: rc.not_verifiable_count, color: FINDING_STATUS_CONFIG.not_verifiable.color },
        { name: 'Needs More Data', value: rc.potentially_verifiable_count, color: FINDING_STATUS_CONFIG.potentially_verifiable.color },
      ].filter((d) => d.value > 0),
      innerRadius: '50%',
      outerRadius: '75%',
      labelFormatter: 'nameAndValue',
    });
  });

  statusBreakdown = computed(() => {
    const rc = this.reportCard();
    return [
      { label: 'Validated', count: rc.validated_count, color: FINDING_STATUS_CONFIG.validated.color },
      { label: 'Not Validated', count: rc.documented_not_validated_count, color: FINDING_STATUS_CONFIG.documented_not_validated.color },
      { label: 'Recommended', count: rc.recommended_not_documented_count, color: FINDING_STATUS_CONFIG.recommended_not_documented.color },
      { label: 'Not Verifiable', count: rc.not_verifiable_count, color: FINDING_STATUS_CONFIG.not_verifiable.color },
      { label: 'Needs More Data', count: rc.potentially_verifiable_count, color: FINDING_STATUS_CONFIG.potentially_verifiable.color },
    ];
  });
}
